import React from 'react'

function HeaderLeft({toggle , setToggle}) {
  return (
    <div className="header-left">
    <div className="header-logo">
        <strong>Attendance</strong>
    <i className="bi bi-calendar-week"></i>
    </div>
    <div onClick={()=> setToggle(prev => !prev)} className="header-menu">
       {toggle ?  <i className="bi bi-x-lg"></i>  :  <i className="bi bi-list"></i>}
    </div>
</div>
  )
}

export default HeaderLeft